<template>
  <div v-if="isVisible" class="notification-modal">
    <base-custom-alert :cardClassColor="'bg-info-light'" :bgClassColor="'bg-info'">
      <template #customAlertIcon>
        <i class="bi bi-bell-fill h4"></i>
      </template>

      <template #customAlertText>
        <button class="btn-close position-absolute" style="top: 8px; right: 8px" @click="closeModal"></button>
        <div v-if="notification">
          <h6>
            <small style="white-space: pre-wrap" class="text-secondary">
              {{ notification.date }} - {{ notification.sourceGroup }} -
              {{ notification.sourceApp }}
            </small>
          </h6>
          <p><strong>Mensagem:</strong> {{ notification.msg }}</p>
        </div>
        <div v-else>
          <p>Nenhuma notificação selecionada.</p>
        </div>
      </template>
    </base-custom-alert>
  </div>
</template>

<script>
import BaseCustomAlert from "@/ui/BaseCustomAlert.vue";

export default {
  components: { BaseCustomAlert },
  computed: {
    notification() {
      return this.$store.getters.getCurrentNotification;
    },
    isVisible() {
      return (
        this.$store.getters.getToggleNotificationModal && this.notification
      );
    },
  },
  methods: {
    closeModal() {
      this.$store.commit("toggleNotificationModal", false);
    },
  },
};
</script>

<style scoped>
.notification-modal {
  width: min(100%, 720px);
  margin: 12px auto 0;
}
</style>
